var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainingEnablementBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 332,
    viewBox: "0 0 288 332",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H288V332H0V0Z",
    fill: "#264468"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_117_890",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 288,
    height: 332
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H288V332H0V0Z",
    fill: "#264468"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_117_890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.5 306.5C412.5 380.541 353.367 440.5 280.5 440.5C207.633 440.5 148.5 380.541 148.5 306.5C148.5 232.459 207.633 172.5 280.5 172.5C353.367 172.5 412.5 232.459 412.5 306.5Z",
    stroke: "#83ADC6",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.5 87.5C210.5 157.631 152.53 214.5 81 214.5C9.46993 214.5 -48.5 157.631 -48.5 87.5C-48.5 17.3689 9.46993 -39.5 81 -39.5C152.53 -39.5 210.5 17.3689 210.5 87.5Z",
    stroke: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingEnablementBg);
export default __webpack_public_path__ + "static/media/training-enablement-bg.7bda42cbba78a6a50f8853a8c50bbfa4.svg";
export { ForwardRef as ReactComponent };